import {
  Currency,
  JobsVacancyEmployment,
  JobsEmployersProductMaturity,
  JobsVacancySubmissionEquity,
} from '@/types/graphql';
import type { CurrencyData } from '~/components/partials/jobs/types';

export const modalNames = Object.freeze({
  JOBS_GETTING_STARTED: 'jobs-getting-started',
  JOBS_EDIT_DESIRED_CRITERIA: 'jobs-edit-desired-criteria',
  JOBS_EDIT_QUOTA: 'jobs-edit-quota',
  JOBS_EDIT_SALARY: 'jobs-edit-salary',
  JOBS_SCHEDULE_MEETING: 'jobs-schedule-meeting',
  JOBS_CONFIRM_INQUIRY_ACTIVATION: 'jobs-confirm-inquiry-activation',
  JOBS_COMPLETE_SURVEY: 'jobs-complete-survey',
  JOBS_NO_MATCHES_FOUND: 'jobs-no-matches-found',
  JOBS_MATCHED_COMPANIES: 'jobs-matched-companies',
  JOBS_PROFILE_RENEWED: 'jobs-profile-renewed',
  JOBS_LOOKING_FOR_OPPORTUNITIES: 'jobs-looking-for-opportunities',
  SIGN_IN: 'sign-in',
  SIGN_UP: 'sign-up',
  SGPT_FEEDBACK: 'sgpt-feedback',
});

export const profileSections = Object.freeze({
  USER: 'userSection',
  QUOTA: 'quotaSection',
  SALARY: 'salarySection',
  DESIRED: 'desiredSection',
});

export const IS_REDIRECTED_FROM_JOBS_ONBOARDING = 'is-redirected-from-jobs-onboarding';
export const IS_REDIRECTED_FROM_ONBOARDING = 'is-redirected-from-onboarding';
export const REFERER_IS_JOB_POSTING_LINK = 'referer-is-job-posting-link';
export const IS_SELECTED_JOBS_PRODUCT = 'is-selected-jobs-product';
export const AFTER_ONBOARDING_SURVEY_EVENT = 'after-onboarding-survey-event';

export const JOBS_PAIRED_CANDIDATES_SURVEY_EVENT_NAME = 'jobs_paired_candidates';
export const JOBS_UNPAIRED_CANDIDATES_SURVEY_EVENT_NAME = 'jobs_unpaired_candidates';

export const EMPLOYMENT_TYPES = {
  [JobsVacancyEmployment.Contract]: 'Contract to hire',
  [JobsVacancyEmployment.FullTime]: 'Full time',
  [JobsVacancyEmployment.SideHustle]: 'Side hustle',
};

export const PRODUCT_MATURITY_NAMES = {
  [JobsEmployersProductMaturity.BrandNew]: 'Brand New Product',
  [JobsEmployersProductMaturity.Newer]: 'Newer Product',
  [JobsEmployersProductMaturity.Established]: 'Established',
};

export const LINKEDIN_JOBS_VACANCY_UID_COOKIE_NAME = 'linkedinJobsVacancyUid';

export const CONTRACTOR_ROLE_TOOLTIP_NAME = 'jobs:contractor-role-modal';

export const currencyMap: Record<Currency, CurrencyData> = {
  [Currency.Usd]: {
    name: 'US Dollars',
    labelTitle: 'US dollars',
    placeholderTitle: 'Dollars',
    symbol: '$',
  },
  [Currency.Inr]: {
    name: 'Indian Rupees',
    labelTitle: 'Rupees',
    placeholderTitle: 'Rupees',
    symbol: '₹',
  },
};

export const EQUITY_OPTIONS = [
  {
    id: JobsVacancySubmissionEquity.None,
    name: 'None',
  },
  {
    id: JobsVacancySubmissionEquity.Percent_0_01To_0_05,
    name: '0.01% - 0.05%',
  },
  {
    id: JobsVacancySubmissionEquity.Percent_0_05To_0_1,
    name: '0.05% - 0.1%',
  },
  {
    id: JobsVacancySubmissionEquity.Percent_0_1To_0_5,
    name: '0.1% - 0.5%',
  },
  {
    id: JobsVacancySubmissionEquity.Percent_0_5To_1,
    name: '0.5% - 1%',
  },
  {
    id: JobsVacancySubmissionEquity.MoreThan_1,
    name: '>1%',
  },
];
